import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { getZCmsDocumentSelectForTypeSlug } from './models';

const c = initContract();

const ZNotFound = z.object({ message: z.string() });

// ─── Contract ─────────────────────────────────────────────────────────────────
// API response uses .partial() because JSONB rows from old documents may be missing keys
export const publicCmsContract = c.router(
  {
    listWinners: {
      method: 'GET',
      path: '/winners',
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('winner').array(),
      },
      summary: 'List published Winner documents',
    },

    getWinner: {
      method: 'GET',
      path: '/winners/:id',
      pathParams: z.object({ id: z.coerce.number() }),
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('winner'),
        404: ZNotFound,
      },
      summary: 'Get a published Winner document by ID',
    },

    listWinnerPolaroids: {
      method: 'GET',
      path: '/winner-polaroids',
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('winner-polaroid').array(),
      },
      summary: 'List published WinnerPolaroid documents',
    },

    getWinnerPolaroid: {
      method: 'GET',
      path: '/winner-polaroids/:id',
      pathParams: z.object({ id: z.coerce.number() }),
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('winner-polaroid'),
        404: ZNotFound,
      },
      summary: 'Get a published WinnerPolaroid document by ID',
    },

    listReviews: {
      method: 'GET',
      path: '/reviews',
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('review').array(),
      },
      summary: 'List published Review documents',
    },

    getReview: {
      method: 'GET',
      path: '/reviews/:id',
      pathParams: z.object({ id: z.coerce.number() }),
      responses: {
        200: getZCmsDocumentSelectForTypeSlug('review'),
        404: ZNotFound,
      },
      summary: 'Get a published Review document by ID',
    },
  },
  { pathPrefix: '/public', strictStatusCodes: true },
);
